
const account = {
  // Account
  account: {
    profile: "Profile",
    settings: "Settings",
    preferences: "Preferences",
    subscription: "Subscription",
    billingHistory: "Billing History"
  }
};

export default account;
